// THIS FILE IS AUTOGENERATED
// DO NOT EDIT THIS FILE DIRECTLY
// PLEASE RUN `pnpm run generate:twMergeConfig` TO UPDATE THIS FILE
import { defaultConfig } from 'tailwind-variants';

export const twMergeConfig: (typeof defaultConfig)['twMergeConfig'] = {
  override: {
    theme: {
      'color': [
        'transparent',
        'matcha-green',
        'matcha-purple',
        'matcha-orange',
        'matcha-red',
        'white-700',
        'white-1000',
        'primitive-gray-40',
        'primitive-gray-100',
        'primitive-gray-200',
        'primitive-gray-300',
        'primitive-gray-400',
        'primitive-gray-500',
        'primitive-gray-600',
        'primitive-gray-700',
        'primitive-gray-800',
        'primitive-gray-900',
        'primitive-gray-1000',
        'primitive-gray-1100',
        'primitive-gray-1200',
        'primitive-gray-1300',
        'primitive-gray-1400',
        'primitive-gray-1500',
        'primitive-gray-1600',
        'primitive-green-100',
        'primitive-green-200',
        'primitive-green-300',
        'primitive-green-400',
        'primitive-green-500',
        'primitive-green-600',
        'primitive-green-700',
        'primitive-green-800',
        'primitive-green-900',
        'primitive-green-1000',
        'primitive-green-1100',
        'primitive-green-1200',
        'primitive-green-1300',
        'primitive-green-1400',
        'primitive-green-1500',
        'primitive-green-1600',
        'primitive-orange-100',
        'primitive-orange-200',
        'primitive-orange-300',
        'primitive-orange-400',
        'primitive-orange-500',
        'primitive-orange-600',
        'primitive-orange-700',
        'primitive-orange-800',
        'primitive-orange-900',
        'primitive-orange-1000',
        'primitive-orange-1100',
        'primitive-orange-1200',
        'primitive-orange-1300',
        'primitive-orange-1400',
        'primitive-orange-1500',
        'primitive-orange-1600',
        'primitive-purple-100',
        'primitive-purple-200',
        'primitive-purple-300',
        'primitive-purple-400',
        'primitive-purple-500',
        'primitive-purple-600',
        'primitive-purple-700',
        'primitive-purple-800',
        'primitive-purple-900',
        'primitive-purple-1000',
        'primitive-purple-1100',
        'primitive-purple-1200',
        'primitive-purple-1300',
        'primitive-purple-1400',
        'primitive-purple-1500',
        'primitive-purple-1600',
        'primitive-red-100',
        'primitive-red-200',
        'primitive-red-300',
        'primitive-red-400',
        'primitive-red-500',
        'primitive-red-600',
        'primitive-red-700',
        'primitive-red-800',
        'primitive-red-900',
        'primitive-red-1000',
        'primitive-red-1100',
        'primitive-red-1200',
        'primitive-red-1300',
        'primitive-red-1400',
        'primitive-red-1500',
        'primitive-red-1600',
        'primitive-alphalight-100',
        'primitive-alphalight-200',
        'primitive-alphalight-300',
        'primitive-alphalight-400',
        'primitive-alphalight-500',
        'primitive-alphalight-600',
        'primitive-alphalight-700',
        'primitive-alphalight-800',
        'primitive-alphalight-900',
        'primitive-alphalight-1000',
        'primitive-alphalight-1100',
        'primitive-alphalight-1200',
        'primitive-alphalight-1300',
        'primitive-alphalight-1400',
        'primitive-alphalight-1500',
        'primitive-alphalight-1600',
        'primitive-alphadark-100',
        'primitive-alphadark-200',
        'primitive-alphadark-300',
        'primitive-alphadark-400',
        'primitive-alphadark-500',
        'primitive-alphadark-600',
        'primitive-alphadark-700',
        'primitive-alphadark-800',
        'primitive-alphadark-900',
        'primitive-alphadark-1000',
        'primitive-alphadark-1100',
        'primitive-alphadark-1200',
        'primitive-alphadark-1300',
        'primitive-alphadark-1400',
        'primitive-alphadark-1500',
        'primitive-alphadark-1600',
        'primitive-basic-black',
        'primitive-basic-white',
        'token-alphalight-100',
        'token-alphalight-200',
        'token-alphalight-300',
        'token-alphalight-400',
        'token-alphalight-500',
        'token-alphalight-700',
        'token-gray-100',
        'token-gray-200',
        'token-gray-300',
        'token-gray-400',
        'token-gray-500',
        'token-gray-600',
        'token-gray-700',
        'token-gray-800',
        'token-gray-900',
        'token-gray-1000',
        'token-gray-1200',
        'token-gray-1600',
        'token-green-100',
        'token-green-300',
        'token-green-400',
        'token-green-900',
        'token-green-1000',
        'token-green-1100',
        'token-green-1200',
        'token-orange-200',
        'token-orange-300',
        'token-orange-400',
        'token-orange-500',
        'token-orange-900',
        'token-orange-1100',
        'token-purple-200',
        'token-purple-300',
        'token-purple-400',
        'token-purple-500',
        'token-purple-600',
        'token-purple-900',
        'token-purple-1000',
        'token-purple-1100',
        'token-red-200',
        'token-red-300',
        'token-red-400',
        'token-red-600',
        'token-red-900',
        'token-red-1000',
        'token-red-1300',
        'special-avatar-pink',
        'special-background-app',
        'special-content-select-button-primary',
        'special-content-button-primary-black',
        'special-background-button-medium-secondary',
        'special-background-button-medium-secondary-hover',
        'special-background-button-medium-secondary-pressed',
        'special-background-button-red-primary',
        'special-background-button-red-primary-hover',
        'special-background-button-red-primary-pressed',
        'special-background-button-red-secondary',
        'special-background-button-red-secondary-hover',
        'special-background-button-red-secondary-pressed',
        'special-background-button-purple',
        'special-background-button-purple-hover',
        'special-background-button-purple-pressed',
        'special-background-button-switch',
        'special-background-button-tokens',
        'special-background-homepage',
        'special-background-modal',
        'special-background-navbar',
        'special-background-overlay',
        'special-background-tooltip',
        'special-background-card',
        'special-border-avatar',
        'special-border-avatar-mask',
        'special-border-button-tokens',
        'special-border-card',
        'special-border-divider',
        'special-xchain-stroke',
        'special-trade-type-bridge',
        'special-border-button-red-secondary-focus',
        'special-content-button-tokens',
        'special-content-button-purple',
        'special-content-pill-tokens',
        'special-content-button-red-primary-disabled',
        'special-content-button-red-secondary-disabled',
        'special-mb-success-start-color',
        'special-mb-info-color',
      ],
      'breakpoint': ['mobile', 'tablet', 'desktop', 'header-lg', 'header-md', 'header-sm'],
      'shadow': [
        '05',
        '10',
        '15',
        '25',
        '30',
        'purple',
        'green',
        'inner-05',
        'inner-10',
        'modal-badge',
      ],
      'font': [
        'weight-*',
        'weight-normal',
        'weight-medium',
        'weight-semibold',
        'weight-bold',
        'weight-extrabold',
        'heading',
        'body',
      ],
      'text': [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'body-sm',
        'body-md',
        'body-lg',
        'body-xl',
        'label-xsm',
        'label-sm',
        'label-md',
        'label-lg',
        'caption',
        '300',
        '350',
        '400',
        '450',
        '500',
        '600',
        '650',
        '700',
        '750',
        '800',
        '900',
        '950',
        '1000',
        '1150',
        '1400',
        '1600',
        '1750',
      ],
      'font-weight': ['normal', 'medium', 'semibold', 'bold', 'extrabold'],
      'radius': ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', 'inherit'],
    },
  },
};
